import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";

import TopBar from "@/components/site/TopBar";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import MobileBottomNav from "@/components/site/MobileBottomNav";
import LoginDialog from "@/components/site/LoginDialog";
import { trackVisit } from "@/lib/tracker";

import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import PostProperty from "@/pages/PostProperty";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import Locality from "@/pages/Locality";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function PublicLayout({ children, openLogin }) {
  return (
    <>
      <TopBar onLoginClick={openLogin}/>
      <Navbar onLoginClick={openLogin}/>
      <main className="min-h-screen pb-20 xl:pb-0">{children}</main>
      <Footer/>
      <MobileBottomNav onLoginClick={openLogin}/>
    </>
  );
}

function Shell() {
  const [loginOpen, setLoginOpen] = useState(false);
  const openLogin = () => setLoginOpen(true);
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  useEffect(() => { trackVisit(pathname); }, [pathname]);

  return (
    <>
      <Routes>
        {/* Admin routes — no public chrome */}
        <Route path="/admin/login" element={<AdminLogin/>} />
        <Route path="/admin" element={<Admin/>} />
        <Route path="/admin/:section" element={<Admin/>} />

        {/* Public routes with full site chrome */}
        <Route path="/*" element={
          <PublicLayout openLogin={openLogin}>
            <Routes>
              <Route path="/" element={<Home onLoginClick={openLogin}/>} />
              <Route path="/properties" element={<Properties onLoginClick={openLogin}/>} />
              <Route path="/property/:id" element={<PropertyDetail onLoginClick={openLogin}/>} />
              <Route path="/post-property" element={<PostProperty onLoginClick={openLogin}/>} />
              <Route path="/dashboard/*" element={<Dashboard/>} />
              <Route path="/locality/:name" element={<Locality onLoginClick={openLogin}/>} />
              <Route path="/projects" element={<Projects/>} />
              <Route path="/contact" element={<Contact/>} />
              <Route path="/blog" element={<Blog/>} />
              <Route path="/blog/:slug" element={<BlogPost/>} />
            </Routes>
          </PublicLayout>
        } />
      </Routes>
      {!isAdmin && <LoginDialog open={loginOpen} onOpenChange={setLoginOpen}/>}
      <Toaster position="top-right" richColors/>
    </>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Shell/>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
